import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';
import { LuxonHelpersService } from '../services/luxon-helpers.service';

@Pipe({
  name: 'luxonTimezone',
  standalone: true,
})
export class LuxonTimezonePipe implements PipeTransform {
  private _luxonHelpersService = inject(LuxonHelpersService);
  transform(date: DateTime, timezone: string): DateTime {
    return this._luxonHelpersService.setDateTimeZone(date, timezone);
  }
}
